import React from 'react'
import PropTypes from 'prop-types'
import {
  Row, Button, Icon, Collapse, Radio, Loader,
} from 'shpmtcd'
import AddressItem from '../containers/AddressItem'
import DeleteAddressModal from '../containers/DeleteAddress'

const RadioGroup = Radio.Group

class AddressList extends React.Component {
  render() {
    const {
      addressList,
      isLoading,
      merchantCountry,
      selectedAddressID,
      onSelectNewAddress,
      setMerchantCountry,
      fetchAllStates,
      allCountries,
      setPhoneCode,
    } = this.props
    return (
      <section className='customer-address-list'>
        <h3>My Address</h3>
        { isLoading
          ? (
            <Loader
              transparentCircle
              processText='Fetching Address...'
            />
          )
          : (
            <>
              {
          (addressList && addressList.length === 0) && <Row className='no-address-info'><h3>You have not added an address</h3></Row>
        }

              <RadioGroup style={{ display: 'block' }} value={selectedAddressID} className={`customer-address-group ${addressList.length === 0 ? 'hide-block' : ''}`}>
                <Collapse accordion className='address-list-wrapper'>
                  {
              addressList && addressList.map(
                (address, index) => (
                  <AddressItem
                    index={index}
                    key={address.id}
                    address={address}
                  />
                ),
              )
            }
                </Collapse>
              </RadioGroup>
              <div className='add-new-address text-align--center'>
                <Button
                  type='Icon'
                  className='add-button'
                  onClick={
                    () => {
                      onSelectNewAddress()
                      setMerchantCountry(merchantCountry)
                      setPhoneCode(allCountries, merchantCountry)
                      fetchAllStates(merchantCountry)
                    }
                  }
                >
                  <Icon type='shpmtcdicon-plus' className='PrimaryColor' />
                  <p>Add a new address</p>
                </Button>
              </div>
              <DeleteAddressModal />
            </>
          )}
      </section>
    )
  }
}

AddressList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  merchantCountry: PropTypes.string.isRequired,
  selectedAddressID: PropTypes.string.isRequired,
  onSelectNewAddress: PropTypes.func.isRequired,
  setMerchantCountry: PropTypes.func.isRequired,
  fetchAllStates: PropTypes.func.isRequired,
  setPhoneCode: PropTypes.func.isRequired,
  allCountries: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    phone_code: PropTypes.string,
  })).isRequired,
  addressList: PropTypes.arrayOf(PropTypes.shape({
    address_hash: PropTypes.shape({
      city: PropTypes.string,
      country: PropTypes.string,
      postcode: PropTypes.string,
      poboxnumber: PropTypes.string,
      street_address: PropTypes.string,
    }),
    default_contact: PropTypes.bool,
    selected: PropTypes.bool,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone: PropTypes.string,
    id: PropTypes.number,
  })).isRequired,
}

export default AddressList
